export class DateListingBlock {
    constructor() {
        if (document.querySelector('.date-listing-load-more')) {
            let loadMoreNodeList = document.querySelectorAll('.date-listing-load-more');
            let loadMoreArray = Array.prototype.slice.call(loadMoreNodeList);

            loadMoreArray.forEach(function (loadMoreItem) {
                loadMoreItem.addEventListener('click', function () {
                    // Show all items
                    loadMoreItem.parentElement.querySelector('.date-listing-container-hidden').classList.add('date-listing-container-hidden-open');

                    // Hide view all button
                    loadMoreItem.classList.add('visually-hidden');

                    // Show view less button
                    loadMoreItem.parentElement.querySelector('.date-listing-load-less').classList.remove('visually-hidden');
                })
            })

            let loadLessNodeList = document.querySelectorAll('.date-listing-load-less');
            let loadLessArray = Array.prototype.slice.call(loadLessNodeList);

            loadLessArray.forEach(function (loadLessItem) {
                loadLessItem.addEventListener('click', function () {
                    // Show initial items
                    loadLessItem.parentElement.querySelector('.date-listing-container-hidden').classList.remove('date-listing-container-hidden-open');

                    // Hide view less button
                    loadLessItem.classList.add('visually-hidden');

                    // Show view more button
                    loadLessItem.parentElement.querySelector('.date-listing-load-more').classList.remove('visually-hidden');
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/date-listing-block.ts